import script from "./ExpressCompanies.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpressCompanies.vue?vue&type=script&setup=true&lang=js"

import "./ExpressCompanies.vue?vue&type=style&index=0&id=2607f0bf&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2607f0bf"]])

export default __exports__